var _a;
import { __decorate, __extends } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Glide, GlideSlide } from 'vue-glide-js';
import { breakpoints } from '../../breakpoint-constants';
import SliderHelper from "../../slider-helper";
import 'vue-glide-js/dist/vue-glide.css';
var HeroSlider = /** @class */ (function (_super) {
    __extends(HeroSlider, _super);
    function HeroSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.glideOptions = {
            type: 'carousel',
            perView: 1,
            gap: 0,
            direction: 'ltr',
        };
        _this.currentSlideIndex = 0;
        _this.nextSlideIndex = null;
        _this.lastSlideIndex = null;
        _this.slideCount = null;
        _this.dots = false;
        _this.images = null;
        return _this;
    }
    HeroSlider.prototype.created = function () {
        var _this = this;
        var slot = this.$slots.slide;
        if (slot) {
            slot.map(function (x, i) {
                _this.$slots.slide[i] = _this.$createElement('vue-glide-slide', [_this.$slots.slide[i]]);
            });
            this.slideCount = this.$slots.slide.length;
            this.lastSlideIndex = this.slideCount - 1;
            this.images = this.$slots.slide;
        }
        if (breakpoints().breakpoints.desktop_down) {
            this.dots = true;
        }
    };
    HeroSlider.prototype.handleBeforeChange = function (data) {
        if (data.direction === '=') {
            this.currentSlideIndex = parseInt(data.steps);
        }
        else {
            if (data.direction === '>') {
                this.currentSlideIndex++;
                this.nextSlideIndex = this.currentSlideIndex + 1;
                if (this.currentSlideIndex > this.lastSlideIndex) {
                    this.currentSlideIndex = 0;
                }
                if (this.nextSlideIndex > this.lastSlideIndex) {
                    this.nextSlideIndex = 0;
                }
            }
            else {
                this.currentSlideIndex--;
                this.nextSlideIndex = this.currentSlideIndex - 1;
                if (this.currentSlideIndex < 0) {
                    this.currentSlideIndex = this.lastSlideIndex;
                }
                if (this.nextSlideIndex < 0) {
                    this.nextSlideIndex = this.lastSlideIndex;
                }
            }
        }
        //@ts-ignore
        var slider = this.$refs.glide.$el;
        slider.querySelectorAll('[data-glide-index="' + this.currentSlideIndex + '"]').forEach(function (item) {
            var child = item.firstChild;
            child.style.display = 'block';
            SliderHelper.insertLazyImages(item);
        });
        slider.querySelectorAll('[data-glide-index="' + this.nextSlideIndex + '"]').forEach(function (item) {
            var child = item.firstChild;
            child.style.display = 'block';
            SliderHelper.insertLazyImages(item);
        });
    };
    HeroSlider.prototype.handler = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    __decorate([
        Prop({ default: 0 })
    ], HeroSlider.prototype, "count", void 0);
    __decorate([
        Prop()
    ], HeroSlider.prototype, "children", void 0);
    HeroSlider = __decorate([
        Component({
            components: (_a = {},
                _a[Glide.name] = Glide,
                _a[GlideSlide.name] = GlideSlide,
                _a)
        })
    ], HeroSlider);
    return HeroSlider;
}(Vue));
export default HeroSlider;
